import React from "react";
import { useState, useCallback } from "react";
import { cn } from "@/lib/utils";
import type { CellProps } from "../types";

export function TextCell({
  value,
  onChange,
  disabled,
  placeholder = "Enter text...",
}: CellProps<string>) {
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange]
  );

  return (
    <input
      type="text"
      value={value ?? ""}
      onChange={handleChange}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      disabled={disabled}
      placeholder={placeholder}
      className={cn(
        "w-full h-8 px-2 text-sm bg-transparent rounded",
        "border border-transparent transition-colors",
        "placeholder:text-muted-foreground/50",
        "hover:border-border focus:border-primary focus:outline-none",
        isFocused && "border-primary bg-background/50",
        disabled && "opacity-50 cursor-not-allowed"
      )}
    />
  );
}
